import { FormationDetailProps } from '@/types/formation';

export const macCatecFormation: FormationDetailProps = {
  id: '24',
  title: 'Formation MAC CATEC®',
  description: 'Maintien et Actualisation des Compétences – Intervenants & Surveillants – R472 R447',
  duration: '7h (1 jour)',
  category: 'Sécurité - Recyclage',
  imageSrc: '/images/formations/catecfiche.webp',
  slug: 'mac-catec',
  reference: 'R472-R447-MAC',
  price: 'Sur devis – nous contacter',
  habilitation: 'Sous habilitation N° H30797/2023/Catec-1/0/16',
  
  // Détails supplémentaires
  objectives: [
    'Actualiser les connaissances et les pratiques des professionnels déjà certifiés CATEC®',
    'Vérifier le maintien des compétences dans le domaine des interventions en espaces confinés',
    'S\'entraîner à la résolution de situations dégradées ou d\'accidents',
    'Renouveler la certification CATEC® pour une nouvelle période de 3 ans'
  ],
  
  targetAudience: 'Surveillants et intervenants dans les métiers de l\'eau potable et de l\'assainissement',
  
  prerequisites: [
    'Être titulaire d\'un certificat CATEC® en cours de validité',
    'Avoir une pratique régulière en espaces confinés au cours des 3 dernières années',
    'Attestation écrite des compétences et pratiques récentes par l\'employeur',
    'Tenue de travail et EPI obligatoires',
    'Connaissance des contrôleurs d\'atmosphère, EPI, dispositifs antichute, appareils respiratoires d\'évacuation'
  ],
  
  program: [
    {
      title: 'Rappels théoriques',
      items: [
        'Actualisation de la réglementation R472',
        'Rappel des risques spécifiques des espaces confinés',
        'Évolution des équipements et procédures',
        'Analyse des retours d\'expérience et accidents récents'
      ]
    },
    {
      title: 'Mises en pratique',
      items: [
        'Exercices pratiques basés sur des situations réelles',
        'Simulations de situations dégradées',
        'Mise en œuvre des procédures d\'urgence',
        'Vérification des bonnes pratiques d\'intervention'
      ]
    }
  ],
  
  evaluationMethods: [
    'Questionnaire de positionnement des besoins',
    'Ateliers pratiques évaluatifs',
    'QCM pour l\'évaluation des acquis',
    'Grilles conformes au référentiel CATEC',
    'Évaluation de satisfaction à chaud'
  ],
  
  certification: 'Carte CATEC® Intervenant et/ou Surveillant renouvelée par l\'INRS - Validité : 3 ans',
  
  pedagogicalMethods: [
    '20% théorie, 80% pratique',
    'Exercices pratiques basés sur l\'historique d\'intervention des candidats',
    'Retours d\'expérience, débriefings, démonstrations, QCM',
    'Mises en situation réelles sur ouvrages sécurisés',
    'Supports : diaporamas, cas concrets, vidéos, recommandations CATEC'
  ],
  
  accessibilityCriteria: 'La formation est accessible aux personnes en situation de handicap. Merci de nous contacter en amont pour organiser d\'éventuels aménagements.',
  
  registrationProcess: [
    'Inscription par email',
    'Délai d\'accès basé sur un agenda interne de sessions',
    'Inscription possible jusqu\'à 15 jours avant la session'
  ],
  
  intervenant: 'Les formations CATEC sont réalisées par un organisme habilité par l\'INRS sous l\'habilitation N° H30797/2023/Catec-1/0/16',
  
  formatterInfo: {
    name: 'Sébastien DAVRAINVILLE',
    phone: '06.22.61.04.09',
    email: 'sdpsiformation@orange.fr',
    website: 'www.sdpsiformation.fr'
  },
  
  // Informations spécifiques au MAC
  maintainingKnowledge: 'Cette formation de maintien et d\'actualisation des compétences doit être effectuée avant la date d\'expiration de votre certification actuelle pour maintenir la validité de votre habilitation CATEC®.'
};

export default macCatecFormation;
